import * as Yup from 'yup';

const resetPasswordSchema = Yup.object({
  token: Yup.string().required(),
  email: Yup.string()
    .label('Sähköpostiosoite')
    .email()
    .nullable()
    .required(),
  password: Yup.string()
    .label('Salasana')
    .required()
    .min(8),
  password_confirmation: Yup.string()
    .label('Salasana uudelleen')
    .required()
    .oneOf([Yup.ref('password'), null], 'Salasanojen täytyy olla samat'),
});

export default resetPasswordSchema;

export type ResetPasswordSchema = ReturnType<typeof resetPasswordSchema.cast>;
